import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
	DiscountLabelFlag,
	DiscountLabelText,
	DiscountLabelFlagFirstFree,
	DiscountLabelTextFirstFree
} from './styles';

class DiscountLabel extends PureComponent {
	render() {
		const {
			currencySymbol,
			discountStr="",
			discountType,
			dealDiscount,
			dealDiscountType,
			dealDiscountAmount
		} = this.props;

		if (!discountStr && !dealDiscount) return null;

		let discountText = discountStr;
		// Format % off coupons
		if (discountText) {
			if (discountText.startsWith("-")) {
				discountText = discountText.slice(1);
			}
			discountText += ' Off';
		}

		// Format Deal coupon text
		if (dealDiscount) {
			discountText = dealDiscount.includes("%") ? dealDiscount : (
				`${currencySymbol}${dealDiscount} Off`
			);
		}

		// Show "First Box Free" if card is in a deal, where the deal is 100% off first shipment
		// Or the seller has set up a 100% off first shipment coupon
		const showFirstBoxDiscount = (dealDiscount && dealDiscountType === 4) || discountType === 4;
		if (showFirstBoxDiscount) {
			const firstBoxFree = dealDiscountAmount === 100 || (discountStr||"").includes("100%");
			return (
				<DiscountLabelFlagFirstFree>
					<DiscountLabelTextFirstFree>
						{firstBoxFree ? (<>
							<div>First</div>
							<div>Box Free</div>
						</>) : (<>
							<div>1<sup>st</sup> Box</div>
							<div>{discountText}</div>
						</>)}
					</DiscountLabelTextFirstFree>
				</DiscountLabelFlagFirstFree>
			);
		} else {
			return (
				<DiscountLabelFlag>
					<DiscountLabelText>{discountText}</DiscountLabelText>
				</DiscountLabelFlag>
			);
		}
	}
}

DiscountLabel.propTypes = {
	currencySymbol: PropTypes.string,
	discountStr: PropTypes.string,
	dealDiscount: PropTypes.string,
	discountType: PropTypes.number,
	dealDiscountType: PropTypes.number,
	dealDiscountAmount: PropTypes.number,
};

DiscountLabel.defaultProps = {
	currencySymbol: "$",
	dealDiscount: "",
	discountStr: "",
};

export default DiscountLabel;
